

class ResponseOptionVM {
  uuid: string;
  global_option_id: string | number | null;
  label: string;
  color: string;
  score: number | null;
  rate: number | null;
  enable_score: boolean;
  failed: boolean;

  constructor(data?: Partial<ResponseOptionVM>) {
    this.uuid = data?.uuid || ''
    this.global_option_id = data?.global_option_id || null
    this.label = data?.label || ''
    this.color = data?.color || ''
    this.score = data?.score || null
    this.rate = data?.rate || null
    this.enable_score = data?.enable_score || false
    this.failed = data?.failed || false
  }
}

class ResponseVM {
  uuid: string;
  options: ResponseOptionVM[];

  constructor(data?: Partial<ResponseVM>) {
    this.uuid = data?.uuid || ''
    this.options = data?.options ? data.options.map(option => (option)) : []
  }
}

class ResponsesVM {
  [key: string]: ResponseVM;

  constructor(data?: Record<string, ResponseVM>) {
    if (data) {
      Object.keys(data).forEach(key => {
        this[key] = data[key] instanceof ResponseVM ? data[key] : new ResponseVM(data[key])
      })
    }
  }
}
export {ResponsesVM, ResponseVM, ResponseOptionVM}
